import React from 'react';
const Reply = () => (React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10 },
    React.createElement("g", null,
        React.createElement("path", { d: "m12 5-9.5 7 9.5 7" }),
        React.createElement("path", { d: "m22 19c0-3.866-3.134-7-7-7h-12" }))));
export default Reply;
//# sourceMappingURL=Reply.js.map